import { createSelector } from "@reduxjs/toolkit";

const selectPlayer = (state) => state.player;

export const selectIsPlaying = createSelector(
  [selectPlayer],
  (player) => player.isPlaying,
);

export const selectProgress = createSelector(
  [selectPlayer],
  (player) => player.progress,
);

export const selectDuration = createSelector(
  [selectPlayer],
  (player) => player.duration,
);

export const selectCurrentEntity = createSelector(
  [selectPlayer],
  (player) => player.currentEntity,
);

export const selectStreamType = createSelector(
  [selectPlayer],
  (player) => player.currentStreamType,
);

export const selectCurrentContent = createSelector(
  [selectPlayer],
  (player) => player.currentContent,
);

export const playerInfoSelector = createSelector(
  (state) => state.player,
  (player) => player,
);
